import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { connect } from "react-redux";
import {
  addIMEArticleLike,
  removeIMEArticleLike,
  addIMEArticleComment,
} from "../../../actions/imearticle";
import IMEArticleCommentItem from "./IMEArticleCommentItem";

const IMEArticleItem = ({
  addIMEArticleLike,
  removeIMEArticleLike,
  imearticle: {
    _id,
    avatar,
    text,
    title,
    image,
    companyname,
    comments,
    likes,
    date,
  },
  addIMEArticleComment,
  isAuthenticated,
}) => {
  const [showArticle, setshowArticle] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [comment, setComment] = useState("");
  return (
    <Fragment>
      <div className="article-feed-container">
        <div className="article-feed">
          <img
            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/ime_article_images/${image}`}
            alt="article-avatar"
            className="trending-image"
            onClick={(e) => setshowArticle(e)}
          />
        </div>
        <div className="article-relative">
          <div className="article-avi-container-alt">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
              alt="avatar"
              className="article-avi"
            />
          </div>
        </div>
        <div className="article-feed-desc">
          <div className="article-list-items max-width-sm">
            <ul className="article-items">
              <li className="article-item">
                <i className="fas fa-book-open mx-5 green"></i>
                {title}
              </li>
            </ul>
          </div>
          <div className="date-container">
            <i className="far fa-clock mx-5 green"></i>
            <Moment format="MM/DD/YYYY">{date}</Moment>
          </div>
          {isAuthenticated && (
            <div className="article-icons">
              <ul className="trending-icons">
                <li className="icon mx-5">
                  <i
                    className="far fa-thumbs-up mx-5 green"
                    onClick={() => addIMEArticleLike(_id)}
                  ></i>
                  {likes.length > 0 && <span>{likes.length}</span>}
                  <i
                    className="far fa-thumbs-down green mx-5"
                    onClick={() => removeIMEArticleLike(_id)}
                  ></i>
                </li>
                <li className="icon mx-5">
                  <i className="far fa-comment green mx-5"></i>
                  {comments.length > 0 && <span>{comments.length}</span>}
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      {showArticle && (
        <div className="article-overlay">
          <div className="article-overlay-box">
            <div className="article">
              <div className="poster">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/ime_article_images/${image}`}
                  alt="ime-article-avatar"
                  className="trending-image"
                />
              </div>
              <div className="items-container-published">
                <p className="article-title">{title}</p>
                {/* {keywords.length > 0 &&
                  keywords[0].map((keyword) => (
                    <li className="keywordsArray green">{keyword}</li>
                  ))} */}
                <div className="article-caption">
                  <i className="far fa-clock mr-5 green"></i>
                  <p className="caption">
                    Published <Moment format="MM/DD/YYYY">{date}</Moment>
                  </p>
                </div>
              </div>
              <div className="full-article-info">
                <div className="article-overlay-user">
                  <div>
                    <div className="sub-user">
                      <div className="online-avi-container">
                        <div className="avi-color-border-alt green">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                            className="sub-avi"
                            alt="avi-two"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="phrase-top-container">
                    <p className="phrase-text">
                      <i className="fas fa-globe-americas fa-lg mx-5 green"></i>
                      Life is better when we innovate
                    </p>
                    <div className="phrase-bottom-container">
                      <p className="article-phrase">Together.</p>
                    </div>
                  </div>
                </div>
                <div className="flex-only">
                  {isAuthenticated && (
                    <div className="modal-action-buttons">
                      <div className="modal-action-items">
                        <div className="modal-action-button">
                          <i
                            className="far fa-thumbs-up modal-action-icon fa-lg"
                            onClick={() => addIMEArticleLike(_id)}
                          ></i>
                        </div>
                        <p className="modal-action-text mx-5">
                          {likes.length > 0 && <span>{likes.length}</span>}
                        </p>
                      </div>
                    </div>
                  )}
                  <div
                    className="modal-action-buttons"
                    onClick={() => {
                      if (showComments) {
                        setShowComments(false);
                      } else {
                        setShowComments(true);
                      }
                    }}
                  >
                    <div className="modal-action-items">
                      <div className="modal-action-button">
                        <i className="far fa-comment modal-action-icon fa-lg"></i>
                      </div>
                      <p className="modal-action-text mx-5">
                        {comments.length > 0 && <span>{comments.length}</span>}
                      </p>
                    </div>
                  </div>
                  {isAuthenticated && (
                    <div className="modal-action-buttons">
                      <div className="modal-action-items">
                        <div className="modal-action-button">
                          <i className="far fa-share-square modal-action-icon fa-lg"></i>
                        </div>
                        <p className="modal-action-text">Share</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="article-p white">
                {/* <Blocks blocks={blocks} /> */}
                {text}
              </div>
              <div className="article-desc-comments">
                <i
                  className="fas fa-times fa-3x article-x"
                  onClick={() => setshowArticle(false)}
                ></i>
                <div className="article-comments">
                  <div
                    className="comments-title cursor"
                    onClick={() => {
                      if (showComments) {
                        setShowComments(false);
                      } else {
                        setShowComments(true);
                      }
                    }}
                  >
                    {!showComments && (
                      <div>
                        <i className="far fa-comment fa-lg mx-5 green"></i>
                        Comments
                      </div>
                    )}
                    {showComments && (
                      <div>
                        <i className="far fa-comment fa-lg mx-5 green"></i>
                        Hide Comments
                      </div>
                    )}
                  </div>
                  {showComments && (
                    <div>
                      {isAuthenticated && (
                        <div className="comment-reply-input-container-alt">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              if (comment !== "") {
                                addIMEArticleComment({ comment, _id });
                                setComment("");
                                setshowArticle(false);
                              }
                            }}
                            className="comment-reply-input-hidden"
                          >
                            <input
                              type="text"
                              className="comment-reply-input"
                              name="comment"
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                              placeholder="Enter your comment here..."
                            />
                            <button className="comment-reply-input-button background-green">
                              <i className="far fa-comments"></i>
                            </button>
                          </form>
                        </div>
                      )}
                      {comments.map((comment) => (
                        <IMEArticleCommentItem
                          key={comment._id}
                          comment={comment}
                          id={_id}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

IMEArticleItem.propTypes = {
  imearticle: PropTypes.object.isRequired,
  addIMEArticleLike: PropTypes.func.isRequired,
  removeIMEArticleLike: PropTypes.func.isRequired,
  addIMEArticleComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  addIMEArticleLike,
  removeIMEArticleLike,
  addIMEArticleComment,
})(IMEArticleItem);
